import { render, staticRenderFns } from "./depositReceiveReport.vue?vue&type=template&id=f0486300&scoped=true&"
import script from "./depositReceiveReport.vue?vue&type=script&lang=js&"
export * from "./depositReceiveReport.vue?vue&type=script&lang=js&"
import style0 from "./depositReceiveReport.vue?vue&type=style&index=0&id=f0486300&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0486300",
  null
  
)

export default component.exports